/* Speak Good Do Good - waitlist page behaviour.
   Progressive enhancement only: the form works without this file.

   Guarantees that pressing Enter in the email field submits the form.
   Implicit form submission should already do this, but it is cheap to be
   certain - a visitor who types an address, hits Enter and sees nothing
   happen is a signup lost. */

(function () {
  'use strict';

  var input = document.getElementById('sth-waitlist-email');
  if (!input) return;

  var form = input.form || input.closest('form');
  if (!form) return;

  input.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || event.isComposing) return;

    event.preventDefault();

    if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  });
})();
